var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "125px",
    height: "46px",
    viewBox: "0 0 125 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B7EC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page01-teileidentifikation1",
    transform: "translate(-1360.000000, -289.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANIMATE_intro?draw&delay=1.3",
    transform: "translate(1361.000000, 304.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rounded-icon",
    transform: "translate(0.000000, -15.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "line",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 9,
    points: "0 15.01 99 15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(98.000000, 0.000000)",
    fill: "#04B7EC"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 26 15 0 30"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessArrow);
export default __webpack_public_path__ + "static/media/process-arrow.4656190259afb540f7a58c6a40ff3109.svg";
export { ForwardRef as ReactComponent };